export default __webpack_public_path__ + "static/media/normalMenuIcon.f930faa4.svg";